import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage, validateYupSchema } from "formik";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import * as Yup from "yup";
import "./DeliveryForm.css"; // Import your CSS file
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import GeneralApiService from "../../services/generalServices";
import { setShowMessage } from "../../redux/slices/notificationSlice";
import { useDispatch } from "react-redux";

// Validation schema with Yup
const DeliveryFormSchema = Yup.object().shape({
  customerName: Yup.string().required("Customer name is required"),
  enquiredDate: Yup.date().required("Enquired date is required"),
  village: Yup.string().required("Village is required"),
  taluka: Yup.string().required("Taluka is required"),
  district: Yup.string().required("District is required"),
  customerMobile: Yup.string().required("Customer mobile number is required"),
  whatsappNumber: Yup.string().required("WhatsApp number is required"),
  enquirySource: Yup.string().required("Enquiry Source is required"),
  createdby: Yup.string().required("Created By is required"),
  makeName: Yup.string().required("Make name is required"),
  modelName: Yup.string().required("Model name is required"),
  lost_by: Yup.string().required("Lost by is required"),
  isOldOwned: Yup.boolean(),
  oldmake: Yup.string().when("isOldOwned", {
    is: true, // Only required if isOldOwned is true
    then: (schema) => schema.required("Old Make is required"),
    otherwise: (schema) => schema.notRequired(), // Explicitly not required if isOldOwned is false
  }),
  oldmodel: Yup.string().when("isOldOwned", {
    is: true, // Only required if isOldOwned is true
    then: (schema) => schema.required("Old Model is required"),
    otherwise: (schema) => schema.notRequired(), // Explicitly not required if isOldOwned is false
  }),
  oldyear: Yup.string().when("isOldOwned", {
    is: true, // Only required if isOldOwned is true
    then: (schema) => schema.required("Old Year is required"),
    otherwise: (schema) => schema.notRequired(), // Explicitly not required if isOldOwned is false
  }),
  newPrice: Yup.string().required("New Price is required"),
  oldPrice: Yup.string().required("Old Price is required"),
  remainingPrice: Yup.string(),
  commercialReason: Yup.string().required("Commercial reason is required"),
  nonCommercialReason: Yup.string().required(
    "Noncommercial reason is required"
  ),
  enquiryLostDate: Yup.date().required("Enquiry Lost date is required"),
});
const paymentList = [
  { value: "Cash", label: "Cash" },
  { value: "Loan", label: "Loan" },
];

const cashOptions = [
  { label: "Rokda (In-Hand)", value: "rokda" },
  { label: "Check", value: "check" },
];
const LostForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ev_stage, editData } = location?.state;
  const [banklist, setBankList] = useState([]);
  const [modelslistByAgencyMake, setModelslistByAgencyMake] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [filterModelList, setFilterModelList] = useState([]);
  const [customerData, setCustomerData] = useState({});
  const [makeList, setMakeList] = useState([]);
  const [newModalList, setNewModalist] = useState([]);
  const [reasonlist, setReasonList] = useState({
    commercialList: [],
    nonCommercialList: [],
  });
  const [dspList, setDspList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [talukaList, setTalukaList] = useState([]);
  const [filterdTalukaList, setfilterdTalukaList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [filteredVillageList, setFileredVillageList] = useState([]);
  const [enquirySourceList, setEnqirySourceList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({
    customerName: "",
    enquiredDate: "",
    village: "",
    taluka: "",
    district: "",
    customerMobile: "",
    whatsappNumber: "",
    enquirySource: "",
    createdby: "",
    makeName: "",
    modelName: "",
    lost_by: "",
    isOldOwned: false,
    oldmake: "",
    oldmodel: "",
    oldyear: "",
    newPrice: "",
    oldPrice: "",
    remainingPrice: "",
    commercialReason: "",
    nonCommercialReason: "",
    enquiryLostDate: "",
  });

  const fetchBankList = async () => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/get-bank-list`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      const response = await axios.get(url, config);

      if (response.data?.isSuccess) {
        setBankList(
          response.data.result.map((item) => ({
            value: item.bankname,
            label: item.bankname,
          }))
        );
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchCustomerDetails = async (customerId) => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/general/get-customerData/${customerId}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      const response = await axios.get(url, config);

      if (response.data?.isSuccess) {
        const [rowData] = response.data.result.customerData;
        setCustomerData(rowData);
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getVehicleMakeModels = async () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/get-make-modal-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };

    try {
      const response = await axios.get(url, config);
      if (response && response.data) {
        const {
          makeList,
          modelList,
          modelslistByAgencyMake,
          dspList,
          lostReasonList,
          enquirySourceList,
          districtList,
          talukaList,
          villageList,
        } = response.data.result;
        setMakeList(
          makeList.map((item) => ({ value: item.id, label: item.name }))
        );
        setModelList(modelList);
        setModelslistByAgencyMake(
          modelslistByAgencyMake.map((item) => ({
            value: item.id,
            label: item.modalName,
          }))
        );
        setReasonList({
          commercialList: lostReasonList.map((item) => ({
            value: item.id,
            label: item.commercial_reasons,
          })),
          nonCommercialList: lostReasonList.map((item) => ({
            value: item.id,
            label: item.non_commercial_reasons,
          })),
        });
        setDspList(dspList);
        setEnqirySourceList(enquirySourceList);
        setDistrictList(districtList);
        setTalukaList(talukaList);
        setVillageList(villageList);
      } else {
        setMakeList([]);
        setModelList([]);
        setModelslistByAgencyMake([]);
        setDspList([]);
        setEnqirySourceList([]);
        setDistrictList([]);
        setTalukaList([]);
        setVillageList([]);
      }
    } catch (error) {
      console.error("Error fetching getVehicleMakeModels:", error);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };
  useEffect(() => {
    if (editData && editData.id) {
      fetchCustomerDetails(editData.id);
    }
  }, [editData]);
  useEffect(() => {
    getVehicleMakeModels();
    fetchBankList();
  }, []);

  useEffect(() => {
    console.log(customerData, "---------Lost");
    if (!loading && editData && customerData) {
      setInitialValues({
        customerName: editData.first_name,
        enquiredDate: editData.enquiry_date
          ? moment(editData.enquiry_date).format("YYYY-MM-DD")
          : "",
        village: customerData.village,
        taluka: customerData.taluka,
        district: customerData.district,
        customerMobile: editData.phone_number,
        whatsappNumber: editData.whatsapp_number,
        enquirySource: customerData.enquiry_source_id,
        createdby: customerData.user_created,
        makeName: customerData.manufacture,
        modelName: customerData.modal_id,
        lost_by: customerData.lost_by,
        isOldOwned: customerData.old_tractor === "Yes",
        oldmake: customerData.oldmake,
        oldmodel: customerData.oldmodel,
        oldyear: customerData.oldyear,
        newPrice: (editData.new_tractor_price ?? 0).toString(),
        oldPrice: (editData.old_tractor_price ?? 0).toString(),
        remainingPrice: (editData.remaining_price ?? 0).toString(),
        commercialReason: customerData.commercial_reason_1,
        nonCommercialReason: customerData.non_commercial_reason_2,
        enquiryLostDate: customerData.lost_date
          ? moment(customerData.lost_date).format("YYYY-MM-DD")
          : "",
      });

      setfilterdTalukaList(
        talukaList.filter((val) => val.district_id == customerData.district)
      );
      setFileredVillageList(
        villageList.filter((val) => val.taluka_id == customerData.taluka)
      );

      // Filter new models based on the new make
      const filteredNewModels = modelList
        .filter((model) => model.manufacturerId == customerData.manufacture)
        .map((val) => ({ value: val.id, label: val.modalName }));

      setNewModalist(filteredNewModels);

      const filtered = modelList
        .filter((model) => model.manufacturerId == customerData.oldmake)
        .map((val) => ({ value: val.id, label: val.modalName }));

      setFilterModelList(filtered);
    }
  }, [loading, editData, customerData]);

  const formatRupee = (value) => {
    // Ensure the value has a rupee symbol and only numeric characters after it
    return value.replace(/[^\d]/g, ""); // Keep only numbers
  };

  const years = Array.from({ length: 2024 - 1970 + 1 }, (_, i) => {
    const year = (1970 + i).toString();
    return { value: year, label: year };
  });

  const formatType = (type) =>
    type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

  const handleSubmit = (values) => {
    const processedValues = {
      ...values,
      newPrice: parseInt(values.newPrice.replace(/\s/g, "")) || 0,
      oldPrice: parseInt(values.oldPrice.replace(/\s/g, "")) || 0,
      remainingPrice:
        parseInt(values.remainingPrice.replace(/\s/g, "")) || 0,
    };

    try {
      processedValues["editType"] = ev_stage.type;
      processedValues["customerId"] = editData.id;
      console.log("Processed Form Data:", processedValues);
      const EditRequest = new GeneralApiService();
      EditRequest.editEnquiryStageRequest(processedValues).then((response) => {
        if (response && response.success) {
          const formattedType = formatType(ev_stage.type);
          navigate(`/sale/data/${formattedType}`, {
            state: { stage: ev_stage },
          });
          dispatch(setShowMessage(response.message));
        }
      });
    } catch (error) {
      console.log(error, "Error submitting form");
    }
  };

  return (
    <Container className="bg-white rounded">
      <Row className="justify-content-md-center">
        <Col md={12}>
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={DeliveryFormSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, values, touched, errors, setFieldValue }) => {
              const calculateRemainingPrice = () => {
                const newPrice =
                  parseInt(values.newPrice.replace(/[^\d]/g, ""), 10) || 0;
                const oldPrice =
                  parseInt(values.oldPrice.replace(/[^\d]/g, ""), 10) || 0;
                const remainingPrice = Math.max(newPrice - oldPrice, 0);
                setFieldValue(
                  "remainingPrice",
                  formatRupee(remainingPrice.toString())
                );
              };
              const onDistrictChange = (e) => {
                const selectedDistrict = e.target.value;
                setFieldValue("district", selectedDistrict);
                setfilterdTalukaList(
                  talukaList.filter(
                    (val) => val.district_id == selectedDistrict
                  )
                );
              };
              const onTalukaChange = (e) => {
                const selectedTaluka = e.target.value;
                setFieldValue("taluka", selectedTaluka);
                setFileredVillageList(
                  villageList.filter((val) => val.taluka_id == selectedTaluka)
                );
              };
              const onMaufactureChange = (e) => {
                const selectedMake = e.target.value;
                setFieldValue("makeName", selectedMake);
                const filtered = modelList
                  .filter((model) => model.manufacturerId == selectedMake)
                  .map((val) => ({ value: val.id, label: val.modalName }));

                setNewModalist(filtered);
              };
              const onMakeChange = (e) => {
                const selectedMake = e.target.value;
                setFieldValue("oldmake", selectedMake);
                const filtered = modelList
                  .filter((model) => model.manufacturerId == selectedMake)
                  .map((val) => ({ value: val.id, label: val.modalName }));

                setFilterModelList(filtered);
              };
              return (
                <Form>
                  <Row className="mb-1">
                    <Col md={12}>
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="m-0 form-label">
                          EDIT{" "}
                          {ev_stage.type.charAt(0).toUpperCase() +
                            ev_stage.type.slice(1)}
                        </label>

                        <Button
                          variant="outline-secondary"
                          className="text-muted mt-1"
                          size="small"
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          BACK
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="customerName" className="form-label">
                        Name
                      </label>
                      <Field
                        name="customerName"
                        className="form-control"
                        type="text"
                      />
                      <ErrorMessage
                        name="customerName"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="customerMobile" className="form-label">
                        Phone Number
                      </label>
                      <Field
                        name="customerMobile"
                        className="form-control"
                        type="phone"
                      />
                      <ErrorMessage
                        name="customerMobile"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="whatsappNumber" className="form-label">
                        WhatsApp Number
                      </label>
                      <Field
                        name="whatsappNumber"
                        className="form-control"
                        type="phone"
                      />
                      <ErrorMessage
                        name="whatsappNumber"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="district" className="form-label">
                        District
                      </label>
                      <Field
                        as="select"
                        name="district"
                        className="form-control"
                        onChange={(e) => onDistrictChange(e)}
                      >
                        <option value="" label="Select District" />
                        {districtList.map((dist) => (
                          <option
                            key={dist.value}
                            value={dist.value}
                            label={dist.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="district"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="taluka" className="form-label">
                        Taluka
                      </label>
                      <Field
                        as="select"
                        name="taluka"
                        className="form-control"
                        onChange={(e) => onTalukaChange(e)}
                      >
                        <option value="" label="Select Taluka" />
                        {filterdTalukaList.map((taluka) => (
                          <option
                            key={taluka.value}
                            value={taluka.value}
                            label={taluka.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="taluka"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="village" className="form-label">
                        Village
                      </label>
                      <Field
                        as="select"
                        name="village"
                        className="form-control"
                      >
                        <option value="" label="Select Village" />
                        {filteredVillageList.map((village) => (
                          <option
                            key={village.value}
                            value={village.value}
                            label={village.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="village"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="enquiredDate" className="form-label">
                        Enquiry Date
                      </label>
                      <Field
                        name="enquiredDate"
                        className="form-control"
                        type="date"
                      />
                      <ErrorMessage
                        name="enquiredDate"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="enquirySource" className="form-label">
                        Enquiry Source
                      </label>
                      <Field
                        as="select"
                        name="enquirySource"
                        className="form-control"
                      >
                        <option value="" label="Select Enquiry Source" />
                        {enquirySourceList.map((eos) => (
                          <option
                            key={eos.value}
                            value={eos.value}
                            label={eos.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="enquirySource"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="createdby" className="form-label">
                        Enquiry Ad
                      </label>
                      <Field
                        as="select"
                        name="createdby"
                        className="form-control"
                      >
                        <option value="" label="Select Enquiry Ad" />
                        {dspList.map((eos) => (
                          <option
                            key={eos.value}
                            value={eos.value}
                            label={eos.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="createdby"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="makeName" className="form-label">
                        Manufacture Name
                      </label>
                      <Field
                        as="select"
                        name="makeName"
                        className="form-control"
                        onChange={(e) => onMaufactureChange(e)}
                      >
                        <option value="" label="Select Make" />
                        {makeList.map((make) => (
                          <option
                            key={make.value}
                            value={make.value}
                            label={make.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="makeName"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="modelName" className="form-label">
                        Model Name
                      </label>
                      <Field
                        as="select"
                        name="modelName"
                        className="form-control"
                      >
                        <option value="" label="Select Model" />
                        {newModalList.map((model) => (
                          <option
                            key={model.value}
                            value={model.value}
                            label={model.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="modelName"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="lost_by" className="form-label">
                        Lost By
                      </label>
                      <Field
                        as="select"
                        name="lost_by"
                        className="form-control"
                      >
                        <option value="" label="Select Lost by" />
                        {dspList.map((usr) => (
                          <option
                            key={usr.value}
                            value={usr.value}
                            label={usr.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="lost_by"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  {/* Checkbox for Is Old Owned */}
                  <Row className="mb-2">
                    <Col md={12}>
                      <label className="form-check-label">
                        <Field
                          type="checkbox"
                          name="isOldOwned"
                          className="form-check-input"
                        />{" "}
                        Is Old Owned?
                      </label>
                    </Col>
                  </Row>
                  {values.isOldOwned && (
                    <Row className="mb-3">
                      <Col md={4}>
                        <label htmlFor="oldmake" className="form-label">
                          Make
                        </label>
                        <Field
                          as="select"
                          name="oldmake"
                          className="form-control"
                          onChange={(e) => onMakeChange(e)}
                        >
                          <option value="" label="Select make" />
                          {makeList.map((make) => (
                            <option
                              key={make.value}
                              value={make.value}
                              label={make.label}
                            />
                          ))}
                        </Field>
                        <ErrorMessage
                          name="oldmake"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                      <Col md={4}>
                        <label htmlFor="oldmodel" className="form-label">
                          Model
                        </label>
                        <Field
                          as="select"
                          name="oldmodel"
                          className="form-control"
                        >
                          <option value="" label="Select model" />
                          {filterModelList.map((model) => (
                            <option
                              key={model.value}
                              value={model.value}
                              label={model.label}
                            />
                          ))}
                        </Field>
                        <ErrorMessage
                          name="oldmodel"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                      <Col md={4}>
                        <label htmlFor="oldyear" className="form-label">
                          Year
                        </label>
                        <Field
                          as="select"
                          name="oldyear"
                          className="form-control"
                        >
                          <option value="" label="Select year" />
                          {years.map((year) => (
                            <option
                              key={year.value}
                              value={year.value}
                              label={year.label}
                            />
                          ))}
                        </Field>
                        <ErrorMessage
                          name="oldyear"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                    </Row>
                  )}

                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="newPrice" className="form-label">
                        New Tractor Price
                      </label>
                      <Field
                        name="newPrice"
                        className="form-control"
                        type="text"
                        onBlur={() => {
                          calculateRemainingPrice();
                        }}
                        placeholder="0"
                      />
                      <ErrorMessage
                        name="newPrice"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="oldPrice" className="form-label">
                        Old Tractor Price
                      </label>
                      <Field
                        name="oldPrice"
                        className="form-control"
                        type="text"
                        onBlur={() => {
                          calculateRemainingPrice();
                        }}
                        placeholder="0"
                      />
                      <ErrorMessage
                        name="oldPrice"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="remainingPrice" className="form-label">
                        Remaining Price
                      </label>
                      <Field
                        name="remainingPrice"
                        className="form-control"
                        type="text"
                        placeholder="0"
                        readOnly
                      />
                      <ErrorMessage
                        name="remainingPrice"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="commercialReason" className="form-label">
                        Commercial Reason
                      </label>
                      <Field
                        as="select"
                        name="commercialReason"
                        className="form-control"
                      >
                        <option value="" label="Select Commercial Reason" />
                        {reasonlist.commercialList.map((val) => (
                          <option
                            key={val.value}
                            value={val.value}
                            label={val.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="commercialReason"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label
                        htmlFor="nonCommercialReason"
                        className="form-label"
                      >
                        Non-Commercial Reason
                      </label>
                      <Field
                        as="select"
                        name="nonCommercialReason"
                        className="form-control"
                      >
                        <option value="" label="Select NonCommercial Reason" />
                        {reasonlist.nonCommercialList.map((val) => (
                          <option
                            key={val.value}
                            value={val.value}
                            label={val.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="nonCommercialReason"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="enquiryLostDate" className="form-label">
                        Enquired Lost Date
                      </label>
                      <Field
                        name="enquiryLostDate"
                        className="form-control"
                        type="date"
                      />
                      <ErrorMessage
                        name="enquiryLostDate"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>

                  {/* Save Changes */}
                  <Row className="mb-2">
                    <Col md={12}>
                      <Button
                        variant="outline-primary"
                        className="px-5"
                        type="submit"
                        // disabled={isSubmitting}
                      >
                        Save Changes
                      </Button>

                      <Button
                        variant="outline-primary"
                        className=" ms-2 px-4"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Container>
  );
};

export default LostForm;
